import { createContext, useContext } from 'react';

export const DataUploadUpdateContext = createContext<() => void>(() => void 0);

export const DataUploadUpdateProvider = DataUploadUpdateContext.Provider;

export const useDataUploadUpdate = () => useContext(DataUploadUpdateContext);
